import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class BillGeneration {
  /* 账单生成列表 */
  static getBillGenerationRecordsList(option) {
    let url = `/oa/api/bill/generate/record/list?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 账单生成记录保存 */
  static postSaveBillGenerationRecords(data) {
    const url = `/oa/api/upload/bill/generate/fill/order/weight`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default BillGeneration;